import { forwardRef } from "react";
import { Box, BoxProps } from "@mui/material";
import { CENTERED_RICH_TEXT_SX, useSimpleRichText } from "src/components-mui/common/rich-text/use-simple-rich-text";
import { toSxArray } from "src/utils/mui/sx/sx";

// xl is the biggest font-size for text-content
type IFontSizeKeys = "xs" | "sm" | "md" | "lg" | "xl";
export type ISimpleRichTextFontSize = IFontSizeKeys | IFontSizeKeys[];
export type ISimpleRichTextAlign = "left" | "center";

export interface ISimpleRichTextProps extends BoxProps {
    text: string;
    fontSize?: ISimpleRichTextFontSize;
    align?: ISimpleRichTextAlign;
}

export const SimpleRichText = forwardRef(function SimpleRichText({ text, fontSize, align = "left", sx, ...boxProps }: ISimpleRichTextProps, ref) {
    const simpleRichTextSx = useSimpleRichText();

    return (
        <Box
            ref={ref}
            dangerouslySetInnerHTML={{ __html: text }}
            {...boxProps}
            sx={[
                {
                    fontSize: fontSize,
                },
                ...toSxArray(simpleRichTextSx),
                ...(align === "center" ? toSxArray(CENTERED_RICH_TEXT_SX) : []),
                ...toSxArray(sx),
            ]}
        />
    );
});
